import { Box, styled } from '@planne-software/uni/mui/material';

export const FieldWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
});

export const FieldHelperText = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['text-xs-regular'],
  fontFamily: theme.typography.fontFamily,
  color: theme.tokens.colors['text-color-neutral-stronger'],
}));
